subscription TravelAuthorizationStatementReportStatus($id: UUID!) {
  travelAuthorizationStatementReportStatus(id: $id) {
    document {
      id
    }
    status
  }
}
